import gql from 'graphql-tag';

export default gql`
  subscription subscribeToNewOrder {
    subscribeToNewOrder {
      __typename
      id
      quantity
      note
      packing
      menuItem {
        id
        title
        price
      }
      userId
      userName
      date
    }
  }
`;



// WEBPACK FOOTER //
// ./src/app/graphql/subscriptions/subscribeToNewOrder.ts